












import { StoreActions } from '@/store';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Navigation extends Vue {
  get loggedIn(): boolean {
    return this.$store.state.loggedIn;
  }

  async logout() {
    await this.$store.dispatch(StoreActions.Logout);
    this.$router.push('/logout')
  }
}

